import React from "react";
import { modifyBankAccount } from "../../../../../utility/dataModifier";

function BeneficairyBasicDetails({ details }) {
  const pStyle = {
    color: "black",
    fontSize: 16,
    fontFamily: "Roboto",
    fontWeight: "bold",
    padding: "10px 0px",
  };
  return (
    <div
      style={{
        minWidth: 400,
        maxWidth: 500,
        width: "25%",
        display: "flex",
        justifyContent: "space-between",
        padding: "0px 30px",
      }}
    >
      {/* <RowContainer title={"Name"} value={details?.beneficiaryName} />
      <RowContainer
        title={"Bank Account Number"}
        value={details?.accountNumber}
      />
      <RowContainer title={"Name"} value={details?.beneficiaryName} />
      <RowContainer title={"Name"} value={details?.beneficiaryName} /> */}

      <div>
        <p
          style={{
            ...pStyle,
          }}
        >
          Name
        </p>
        <p
          style={{
            ...pStyle,
          }}
        >
          Bank Account Number
        </p>
        <p
          style={{
            ...pStyle,
          }}
        >
          IFSC Code
        </p>
        <p
          style={{
            ...pStyle,
          }}
        >
          TXn Type
        </p>
      </div>
      <div>
        <p
          style={{
            ...pStyle,
            fontWeight: "400",
          }}
        >
          {details?.beneficiaryName}
        </p>
        <p
          style={{
            ...pStyle,
            fontWeight: "400",
          }}
        >
          {modifyBankAccount(details?.accountNumber)}
        </p>
        <p
          style={{
            ...pStyle,
            fontWeight: "400",
          }}
        >
          {details?.ifscCode}
        </p>
        <p
          style={{
            ...pStyle,
            fontWeight: "400",
          }}
        >
          N/A
        </p>
      </div>
    </div>
  );
}

export default BeneficairyBasicDetails;
